// extracted by mini-css-extract-plugin
module.exports = {"navBar":"Navbar-module_navBar_da39e","navSection":"Navbar-module_navSection_68071","navItem":"Navbar-module_navItem_2fb47","selectedNavItem":"Navbar-module_selectedNavItem_7f8d3"};